// === CF7 EFFECT
import '@nematis/cf7-effect'

// === CSS
import '../../sass/singles/accommodation.scss'

document.addEventListener('DOMContentLoaded', () => {
  // handle availability form controls
  const requesterFromEl = document.querySelector('[name="requester_from"]')
  const requesterToEl = document.querySelector('[name="requester_to"]')
  if (requesterFromEl && requesterToEl) {
    let dateFrom = null
    let dateTo = null

    const changeEventCallback = (e) => {
      const targetEl = e.target
      const newValue = targetEl.value

      // sanitize passed date (ensure from date isn't passed to date, and the other way around)
      switch (targetEl.name) {
        case 'requester_from':
          // don't allow departure date before arrival date
          requesterToEl.setAttribute('min', newValue)
          dateFrom = new Date(newValue)
          dateTo = new Date(requesterToEl.value)
          if (!requesterToEl.value || dateFrom > dateTo) {
            dateTo = new Date(dateFrom.getTime())
            dateTo.setDate(dateFrom.getDate() + 1)
            requesterToEl.value = dateTo.toISOString().slice(0, 10)
          }
          break
        case 'requester_to':
          dateTo = new Date(newValue)
          dateFrom = new Date(requesterFromEl.value)
          if (!requesterFromEl.value || dateFrom > dateTo) {
            dateFrom = new Date(dateTo.getTime())
            dateFrom.setDate(dateTo.getDate() - 1)
            requesterFromEl.value = dateFrom.toISOString().slice(0, 10)
          }
          break
        default:
          break
      }
    }

    requesterFromEl.addEventListener('change', (e) => changeEventCallback(e))
    requesterToEl.addEventListener('change', (e) => changeEventCallback(e))
  }

  const btnShowRenterPhoneEl = document.querySelector('.btn-show-renter-phone')
  if (btnShowRenterPhoneEl) {
    btnShowRenterPhoneEl.addEventListener('click', (e) => {
      e.preventDefault()

      btnShowRenterPhoneEl.classList.add('d-none')
      btnShowRenterPhoneEl.nextElementSibling.classList.remove('d-none')
    })
  }
})
